import MoveIcon from "@mui/icons-material/Forward";
import { Box, Grid, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { Fragment } from "react";
import { useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import CustomSelectVerify from "../../unit/forms/CustomSelectVerify";
import useNotify from "../../unit/useNotify";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import CustomApplicationDialogTitle from "./CustomApplicationDialogTitle";
const defaultIcon = <MoveIcon />;

export default function MoveBulkUpdateButton({ ...props }) {
  const [open, setOpen] = React.useState(false);
  const [moveTo, setMoveTo] = React.useState("");
  const refresh = useRefresh();
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const appId = props.appId ? props.appId : "";
  const appStatus = props.status;
  const record = props?.record;
  // console.log("move update button===>", record);
  //if appStatus is New , return null
  if (appStatus === "New") {
    return null;
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = async (moveToPage: string, move_reason: string) => {
    if (appId) {
      const reqUrl = `applications/actions/moveStatus/` + moveToPage;
      const response = await sendRequest(reqUrl, {
        id: appId,
        data: { move_reason: move_reason },
      });
      if (response && response.code == 200) {
        successNotify("Moved successfully");
        handleClose();
        if (props.cb) {
          props.cb(moveToPage);
        }
        refresh();
        return true;
      } else {
        errorNotify("Failed to move");
        return false;
      }
      // return response.data;
    } else {
      return false;
    }
  };

  let moveToPage = [
    { id: "New", name: "Ready for Screening" },
    { id: "Initial Review", name: "Ready for Initial Review" },
    { id: "Final Review", name: "Ready for Final Review" },
    { id: "To Notify", name: "Ready for Notification" },
    { id: "CounteredAndPreApproved", name: "Ready for Final Approval" },
    { id: "Approved", name: "Ready for Disbursement" },
    { id: "Hold", name: "Hold (Last 90 Days)" },
    { id: "Expired", name: "Expired (Last 90 Days)" },
    { id: "Declined", name: "Declined (Last 90 Days)" },
  ];

  if (appStatus == "Initial Review") {
    //only show New in moveToPage
    moveToPage = moveToPage.filter((item) => item.id === "New");
  } else if (appStatus == "Final Review") {
    //only show New and Initial Review in moveToPage
    moveToPage = moveToPage.filter(
      (item) => item.id === "New" || item.id === "Initial Review"
    );
  } else if (appStatus == "To Notify") {
    //only show New, Initial Review and Final Review in moveToPage
    moveToPage = moveToPage.filter(
      (item) =>
        item.id === "New" ||
        item.id === "Initial Review" ||
        item.id === "Final Review"
    );
  } else if (
    appStatus == "CounteredAndPreApproved" ||
    appStatus == "Countered" ||
    appStatus == "Pre-Approved"
  ) {
    //only show New, Initial Review, Final Review and To Notify in moveToPage
    moveToPage = moveToPage.filter(
      (item) =>
        item.id === "New" ||
        item.id === "Initial Review" ||
        item.id === "Final Review" ||
        item.id === "To Notify"
    );
  } else if (appStatus == "Approved" || appStatus == "Completed") {
    //only show New, Initial Review, Final Review, To Notify and CounteredAndPreApproved in moveToPage
    moveToPage = moveToPage.filter(
      (item) =>
        item.id === "New" ||
        item.id === "Initial Review" ||
        item.id === "Final Review" ||
        item.id === "To Notify" ||
        item.id === "CounteredAndPreApproved"
    );
  } else if (appStatus == "Hold") {
    //only show New, Initial review
    moveToPage = moveToPage.filter(
      (item) => item.id === "New" || item.id === "Initial Review"
    );
  } else if (appStatus == "Expired" || appStatus == "Declined") {
    //only show New initial review, final review, to notify
    moveToPage = moveToPage.filter(
      (item) =>
        item.id === "New" ||
        item.id === "Initial Review" ||
        item.id === "Final Review" ||
        item.id === "To Notify"
    );
  }
  //search appStatus on moveToPage, and remove items after appStatus
  let index = moveToPage.findIndex((item) => item.id === appStatus);
  if (index > -1) {
    moveToPage = moveToPage.slice(0, index);
  }
  //moveToPage, remove Countered, Approved, Declined, Expired
  if (
    appStatus === "Countered" ||
    appStatus === "Approved" ||
    appStatus === "Declined" ||
    appStatus === "Expired"
  ) {
    moveToPage = moveToPage.filter(
      (item) =>
        item.id !== "Countered" &&
        item.id !== "Approved" &&
        item.id !== "Declined" &&
        item.id !== "Expired"
    );
  }

  const moveToPageList: { label: string; value: any }[] = [];
  moveToPageList.push({ label: "Select", value: "" });

  moveToPage.forEach((item) => {
    moveToPageList.push({ label: item.name, value: item.id });
  });
  return (
    <Fragment>
      <Button
        id="btn-application-move"
        onClick={handleClickOpen}
        startIcon={<></>}
        variant="contained"
        size="medium"
        color="inherit"
        sx={{
          fontSize: "14px",
          width: "120px",
          minWidth: "120px",
        }}
      >
        Move
      </Button>
      <Dialog
        id="dialog-application-move"
        aria-labelledby="customized-dialog-title"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="sm"
        PaperProps={{
          component: "form",
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            const status = formJson.moveToPage;
            const move_reason = formJson.move_reason;
            if (moveTo == "" || moveTo == null) {
              document.getElementById("moveToPage")?.focus();
              document.getElementById("moveToPage")?.blur();
              return false;
            }
            if (move_reason == "" || move_reason == null) {
              document.getElementById("move_reason")?.focus();
            }
            const callback = handleSave(status, move_reason);
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 1,
          }}
        >
          {/* <CustomDialogTitle
            title={`${appStatus} Application`}
            subTitle="move"
          /> */}
          <CustomApplicationDialogTitle record={record} subTitle="Move" />
        </DialogTitle>
        <DialogContent sx={{ pb: 0 }}>
          <DialogContentText id="customized-dialog-contenttext">
            <Typography>
              Please select the destination page for this application
            </Typography>
          </DialogContentText>
          <FormControl sx={{ width: "100%", marginBottom: "10px" }}>
            <Grid container>
              <Grid container>
                <Grid item xs={3} sx={{ pt: 1 }}>
                  <HeaderLabelTitle title="Move To Page" required={true} />
                </Grid>
                <Grid item xs={9} sx={{ pt: 1 }}>
                  <CustomSelectVerify
                    fullWidth={true}
                    id="moveToPage"
                    name="moveToPage"
                    optionlist={moveToPageList}
                    required={true}
                    variant="outlined"
                    value={moveTo}
                    onChange={(e: any) => {
                      setMoveTo(e.target.value);
                    }}
                    helperText={"no"}
                  />
                </Grid>
              </Grid>
              <Grid sx={{ mb: 0 }} container>
                <Grid item xs={3} sx={{ pt: 0 }}>
                  <HeaderLabelTitle title="Reason" required={true} />
                </Grid>
                <Grid item xs={9} sx={{ pt: 0 }}>
                  <TextField
                    id="move_reason"
                    name="move_reason"
                    label="Move Reason"
                    variant="outlined"
                    multiline={true}
                    minRows={1}
                    fullWidth
                    required
                    sx={{ width: "100%" }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </FormControl>
          {/* <RanTest /> */}
        </DialogContent>
        <DialogActions
          id="customized-dialog-footer"
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <CustomButtonCancel onClick={handleClose} />
          <Box sx={{ flexGrow: 1 }} />
          <CustomButtonSubmit label="Move" />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
